import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import BottomSheet from '../../../Components/Ui/BottomSheet';
import PinchZoom from '../../../Components/Ui/PinchZoom';
import Icon from '../../../Assets/Icon/CustomIcon';
import { Button } from '../../../Components/MUIs';
import Global from '../../../Services/Common/Global';

export default function WorkStopDetailBottomSheet({
  open,
  ToggleDrawer,
  workStopData,
  stopImageList,
}) {
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <BottomSheet
      open={open}
      onClose={ToggleDrawer('bottom', false)}
      onOpen={ToggleDrawer('bottom', true)}
      isHeaderChildren={true}
      headerText={''}
      headerChildren={
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
            pr: 1,
          }}
        >
          <Typography
            sx={{ fontSize: '18px', fontWeight: 'bold', display: 'flex' }}
          >
            {/* {workInfoDetail.TITLE} */}
          </Typography>
        </Box>
      }
    >
      {stopImageList && stopImageList.length > 0 ? (
        <Box sx={{ position: 'relative', px: 1 }}>
          <Swiper
            modules={[Pagination]}
            slidesPerView={1}
            nested={true}
            style={{
              width: '100%',
              height: '300px',
              borderRadius: '8px',
              border: '1px solid #DFD9D9',
            }}
            onSlideChange={(swiper) => setCurrentIndex(swiper.realIndex)}
          >
            {stopImageList.map((img, idx) => (
              <SwiperSlide key={idx}>
                <PinchZoom
                  componentWrapperStyle={{ width: '100%', height: '100%' }}
                  componentContentStyle={{ width: '100%', height: '100%' }}
                  contents={
                    <Box
                      sx={{
                        width: '100%',
                        height: '300px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        overflow: 'hidden',
                      }}
                    >
                      <img
                        src={`${Global.file.useUrl}files/${img}`}
                        alt={`stop-img-${idx}`}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                        }}
                      />
                    </Box>
                  }
                />
              </SwiperSlide>
            ))}
          </Swiper>

          <Box
            sx={{
              position: 'absolute',
              bottom: 8,
              right: 12,
              background: 'rgba(0,0,0,0.6)',
              color: '#fff',
              padding: '2px 8px',
              borderRadius: '12px',
              fontSize: '12px',
              zIndex: 10,
            }}
          >
            {currentIndex + 1} / {stopImageList.length}
          </Box>
        </Box>
      ) : (
        <Box sx={{ px: 1 }}>
          <Box
            sx={{
              width: '100%',
              height: '200px',
              backgroundColor: '#f3f1f1ff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '8px',
              px: 1,
            }}
          >
            <Icon.WorkInfoBaseImg width={50} height={40} />
          </Box>
        </Box>
      )}

      <Box
        sx={{
          px: 1,
          mt: 1,
          mb: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            backgroundColor: '#fafafaff',
            p: 1,
            borderRadius: 1,
          }}
        >
          <p style={{ fontSize: '16px', fontWeight: 'bold' }}>내용</p>
          <p style={{ fontSize: '16px' }}>{workStopData?.stopComment}</p>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <p style={{ fontSize: '14px' }}>{workStopData?.writerDepNmLast}</p>
          <div style={{ display: 'flex', gap: '5px', fontSize: '14px' }}>
            <p style={{ fontWeight: 'bold', color: '#615e5eff' }}>
              {workStopData?.name}
            </p>
            <p>{workStopData?.position}</p>
          </div>
        </Box>
      </Box>

      <Box
        bgcolor="#fff"
        sx={{
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          p: '8px',
        }}
      >
        <Button
          name="확인"
          sx={{
            width: '100%',
            height: 36,
            borderRadius: '5px',
            backgroundColor: '#57B84D',
            color: '#fff',
            boxShadow: 'none',
          }}
          onClick={(e) => {
            ToggleDrawer('bottom', false)(e);
          }}
        />
      </Box>
    </BottomSheet>
  );
}
